import { inject, Injectable } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class PortalInmobiliariasPersonalizeSession {
  private active = false;

  activate(): void {
    this.active = true;
  }

  has(): boolean {
    return this.active;
  }

  clear(): void {
    this.active = false;
  }
}

export const portalInmobiliariasPersonalizeGuard: CanActivateFn = () => {
  const session = inject(PortalInmobiliariasPersonalizeSession);
  const router = inject(Router);
  return session.has() ? true : router.createUrlTree(['/']);
};
